export default __webpack_public_path__ + "media/vendor/paper-dashboard-2-pro-html-v2.0.1/assets/img/flags/SV-a0f7ea17262572e11996d59f46dde615.png";